import { AppActions } from 'app/actions/app';
import { UserStateModel } from 'app/models';
import { handleActions } from 'redux-actions';
import { clone } from 'lodash';

export interface UserState extends UserStateModel {
	
}

const EMPTY_USER_STATE = {
    accessNormalScenario2: 0,
    authenticated: false,
	certificate: "",
	class: "",
	email: "",
	first: "",
	gender: "",
	id: 0,
	kryURL: "",
	last: "",
	authenticationToken: "",
	level: 0,
	menuScene: "", 
	old_auth: "", 
	password: "", 
	subscription: "", 
	tutorial: "",
	classProduct: "5",
	classicMode: 1
};

const VLEADER_SESSION_STORAGE_AUTH_TOKEN_IDENTIFIER = 'vleader-session-at-id';

// Setup our user reducer!
// Here we define it's inital state as the app loads
const initialState: UserState = EMPTY_USER_STATE;

// And we control any actions the user would like to commit to it
export const userReducer = handleActions<UserState, UserStateModel>(
	{
		[AppActions.Type.USER_LOGIN]: (state: UserState, action: any) => {

			let newUserState = clone(action.payload.payload);

			if (newUserState.email === "student2@simulearn.net") {
				newUserState.classicMode = 2;
			}
			else {
				newUserState.classicMode = parseInt(newUserState.classicMode);
			}

			// Set our authenticated flag before pushing it into state
			newUserState.authenticated = true;

			// Return a new version
			return newUserState;
        },
        [AppActions.Type.USER_LOGOUT]: (state: UserState, action: any) => {
            sessionStorage.setItem(VLEADER_SESSION_STORAGE_AUTH_TOKEN_IDENTIFIER, '');
            return EMPTY_USER_STATE
        },
	},
	initialState
);

// Explicit export for ES modules
export type { UserState };
